import { render } from "./FeaturedSlick.vue?vue&type=template&id=244b9f9a"
import script from "./FeaturedSlick.vue?vue&type=script&lang=js"
export * from "./FeaturedSlick.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/FeaturedSlick.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "244b9f9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('244b9f9a', __exports__)) {
    api.reload('244b9f9a', __exports__)
  }
  
  module.hot.accept("./FeaturedSlick.vue?vue&type=template&id=244b9f9a", () => {
    api.rerender('244b9f9a', render)
  })

}


export default __exports__